import { FC } from 'react';
import { SecondaryTextTypography } from '../../../../App.styles';
import { Tooltip, Typography } from '../../../../stories/atoms';
import { Typographies } from '../../../../theme';

export type HeaderTooltipProps = {
  headerText: string;
  headerTextType?: Typographies;
  isSecondaryText?: boolean;
  tooltipText?: string;
};

export const HeaderTooltip: FC<HeaderTooltipProps> = ({
  headerText,
  headerTextType = 'body3',
  isSecondaryText = false,
  tooltipText,
}) => {
  return (
    <Tooltip
      text={
        <Typography padding={[1]} color="white">
          {tooltipText}
        </Typography>
      }
      position="bottom"
      isVisible={!!tooltipText}
    >
      <div>
        {isSecondaryText && <SecondaryTextTypography type={headerTextType}>{headerText}</SecondaryTextTypography>}
        {!isSecondaryText && <Typography type={headerTextType}>{headerText}</Typography>}
      </div>
    </Tooltip>
  );
};
